import { Routes, Route } from "react-router-dom";
import BadgeList from "./list";
import BadgeForm from "./form";

function BadgePage() {
	return (
		<Routes>
			<Route path="/" element={<BadgeList />} />
			<Route path="/add" element={<BadgeForm />} />
			<Route path="/:id/edit" element={<BadgeForm />} />
		</Routes>
	);
}

export default BadgePage;
